import { render, staticRenderFns } from "./new7.vue?vue&type=template&id=3200f564&scoped=true&"
import script from "./new7.vue?vue&type=script&lang=js&"
export * from "./new7.vue?vue&type=script&lang=js&"
import style0 from "./new7.vue?vue&type=style&index=0&id=3200f564&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200f564",
  null
  
)

export default component.exports